import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/LoginModal";
import { UnauthorizedError } from "../errors/http_errors";
import { Administrator } from "../models/administrator";
import { LoginCredentials } from "../models/credentials";
import * as AdministratorsApi from "../network/administrators-api";
import styleUtils from "../styles/utils.module.css";

interface AdministratorAuthPageProps {
    onLoginSuccessful: (administrator: Administrator) => void,
}

const AdministratorAuthPage = ({onLoginSuccessful}: AdministratorAuthPageProps) => {
    const [errorText, setErrorText] = useState<string | null>(null);
    let navigate = useNavigate();
    const routeChange = () =>{
        let path = `cabinet`;
        navigate(path);
    }
    async function onSubmit(credentials: LoginCredentials) {
        try {
            const user = await AdministratorsApi.login(credentials);
            onLoginSuccessful(user);
            routeChange();
        } catch (error) {
            if (error instanceof UnauthorizedError) {
                setErrorText(error.message);
            } else {
                alert(error);
            }
            console.error(error);
        }
    }

    return (
        <>
            <h1 className={styleUtils.flexCenter}>Авторизация администратора</h1>
            <LoginModal errorText={errorText} onSubmit={onSubmit}/>
        </>
        
);
}

export default AdministratorAuthPage;